import React from 'react';
import { useTranslation } from 'react-i18next';
import { TabSelector as TabSelectorUI } from '@jagad/ui';
import type { TabSelectorProps, Tab } from '@jagad/ui';
import { RedemptionType } from '../../types/redemption';

export type { TabSelectorProps, Tab };

export interface RedeemTabProps {
  activeTab: RedemptionType;
  setActiveTab: (tab: RedemptionType) => void;
}

// Original RedeemTab component for backward compatibility
export const RedeemTab: React.FC<RedeemTabProps> = ({ activeTab, setActiveTab }) => {
  const { t } = useTranslation();

  const tabs: Tab<RedemptionType>[] = [
    { value: 'BANK', label: t('components.redeemTab.bankTab') },
    { value: 'E-WALLET', label: t('components.redeemTab.eWalletTab') },
  ];

  return <TabSelectorUI tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />;
};

export { TabSelectorUI as default };
